export function capitalizeFirstChar(string = '') {
    return string[0]?.toUpperCase() + string?.slice(1);
}
